import moment from "moment/moment";
import React from "react";
import { Link } from "react-router-dom";
import { Col, Button } from "reactstrap";
import { baseURL } from "../Axios";
import icon from "../assets/img/placeholder.png";

const Usercard = ({
  id,
  profileId,
  image,
  name,
  gender,
  dob,
  lastSeen,
  state,
  district,
  status,
  email,
  countryCode,
  phone,
  deletedReason,
  createdAt,
  paymentStatus,
  onDelete,
  onActive,
  errorButtonText = "Inactive",
}) => {
  // ✅ Calculate Age
  const calculateAge = (dob) => {
    const birthDate = moment(dob, ["DD-MM-YYYY", "YYYY-MM-DD"]);
    if (!birthDate.isValid()) return { years: "-", months: "-" };
    const today = moment();
    const years = today.diff(birthDate, "years");
    birthDate.add(years, "years");
    const months = today.diff(birthDate, "months");
    return { years, months };
  };

  const { years, months } = calculateAge(dob);

  // ✅ Format CreatedAt (DD/MM/YYYY)
  const formattedCreatedAt = createdAt
    ? moment(createdAt).format("DD/MM/YYYY")
    : "-";

  // ✅ Calculate Last Seen (like "1 day ago", "2 hours ago")
  const formattedLastSeen = lastSeen
    ? moment(lastSeen, [
        "DD/MM/YYYY",
        "YYYY-MM-DD",
        "YYYY-MM-DDTHH:mm:ssZ",
      ]).fromNow()
    : "Not available";

  return (
    <Col xs={12} md={6} lg={4}>
      <div
        className="card"
        style={{
          width: "100%",
          padding: "20px",
          marginBottom: "24px",
          border: "1px solid #dcdcdc",
          borderRadius: "12px",
          background: "#fff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
        }}
      >
        {/* Top Info Row (Last Seen + Age) */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            color: "#999",
            marginBottom: "10px",
          }}
        >
          <span>Last seen: {formattedLastSeen}</span>
          <span>
            {years} years & {months} months
          </span>
        </div>

        {/* Profile Info */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
            borderBottom: "1px solid #f2f2f2",
            paddingBottom: "16px",
            marginBottom: "16px",
          }}
        >
          <img
            src={image ? baseURL + image : icon}
            alt="Profile"
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "8px",
              objectFit: "cover",
              border: "1px solid #eee",
              background: "#fafafa",
            }}
          />
          <div style={{ flex: 1 }}>
            <h5
              style={{
                fontWeight: 700,
                fontSize: "18px",
                color: "#222",
                marginBottom: "4px",
              }}
            >
              {name}
              <span
                style={{
                  marginLeft: "10px",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#4caf50",
                  background: "#e6f4ea",
                  padding: "2px 8px",
                  borderRadius: "6px",
                }}
              >
                {profileId}
              </span>
            </h5>
            <ul
              style={{
                listStyle: "none",
                paddingLeft: 0,
                marginBottom: 0,
                fontSize: "14px",
                color: "#555",
                lineHeight: "1.7",
              }}
            >
              <li style={{ textTransform: "capitalize" }}>{gender}</li>
              <li>{email}</li>
              <li>
                {countryCode} {phone}
              </li>
              <li style={{ textTransform: "capitalize" }}>
                {district}, {state}
              </li>
            </ul>
          </div>
        </div>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Link
            to={`/dashboard1/${id}`}
            className="btn"
            style={{
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid #dee2e6",
              background: "#f6f8fa",
              color: "#333",
              borderRadius: "5px",
              padding: "6px 18px",
            }}
          >
            <i className="bi bi-eye-fill"></i> View
          </Link>

          {status !== "terminated" && (
            <Button
              onClick={onDelete}
              style={{
                fontSize: "14px",
                fontWeight: 500,
                background: "#fff",
                border: "1px solid #e34c43",
                color: "#e34c43",
                borderRadius: "5px",
                padding: "6px 18px",
              }}
            >
              Delete
            </Button>
          )}

          {status ? (
            status === "terminated" ? (
              <span
                className="btn"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  background: "#e9ecef",
                  color: "#aaa",
                  borderRadius: "5px",
                  padding: "6px 18px",
                  cursor: "not-allowed",
                }}
              >
                {errorButtonText}
              </span>
            ) : (
              <Button
                onClick={onActive}
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  background: status === "active" ? "#25c685" : "#0074d9",
                  color: "#fff",
                  borderRadius: "5px",
                  padding: "6px 18px",
                  border: "none",
                }}
              >
                {status}
              </Button>
            )
          ) : null}
        </div>

        {/* Bottom Info Row (Created At + Payment Status) */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13px",
            color: "#999",
            marginTop: "12px",
          }}
        >
          <span>{formattedCreatedAt}</span>
          <span>{paymentStatus}</span>
        </div>
      </div>
    </Col>
  );
};

export default Usercard;
